export enum PapRequestStatusType {
  Requested = 'requested',
  Reserved = 'reserved',
  Conflict = 'conflict',
  TailorMade = 'tailorMade',
  WaitingForAlternative = 'waitingForAlternative',
  ReservedAlternative = 'reservedAlternative',
  AlternativeOffered = 'alternativeOffered',
  AlternativeRejected = 'alternativeRejected',
  AlternativeAccepted = 'alternativeAccepted',
  Drafted = 'drafted'
}
